import { Center, Box, BoxProps } from '@chakra-ui/react'
import { useSpring, animated } from 'react-spring'
import { useWindowSize } from 'react-use'
import { withPrefix } from 'gatsby'
import * as React from 'react'

import { LocalizedText } from '../common/Text'
import { useResponsive } from '../../hooks/useResponsive'
import { vw } from '../../styles/theme'
import Button from '../buttons/Button'
import Carousel from '../carousel/Carousel'
import Image from '../common/Image'

const AnimatedCarousel = animated(Carousel)
export type ArtistsModalProps = BoxProps & {
  index: number
  products: { thumb: string; image: string; title: string; credit: string }[]
}

const ArtistsModal: React.FC<ArtistsModalProps> = ({ index, products, ...others }) => {
  const { height } = useWindowSize()

  const platform = useResponsive('sp', 'pc')
  const [current, setCurrent] = React.useState(index)
  const [from, setFrom] = React.useState(withPrefix(products[index % products.length].image))
  const [to, setTo] = React.useState(withPrefix(products[(index + 1) % products.length].image))
  const [styles, api] = useSpring(() => ({ progress: 0 }))

  React.useEffect(() => {
    const disableScroll = (e: TouchEvent) => {
      e.preventDefault()
    }
    document.addEventListener('touchmove', disableScroll, { passive: false })
    return () => {
      document.removeEventListener('touchmove', disableScroll)
    }
  }, [])

  const handleClick = (isNext: boolean) => {
    setFrom(withPrefix(products[current].image))
    if (isNext) {
      const next = (current + 1) % products.length
      setCurrent(next)
      setTo(withPrefix(products[next].image))
    } else {
      const next = (current + products.length - 1) % products.length
      setCurrent(next)
      setTo(withPrefix(products[next].image))
    }
    api.start({
      config: { duration: 1000 },
      from: { progress: 0 },
      to: { progress: 1 },
    })
  }

  return (
    <>
      <Box bg="black" {...others}>
        <Center w="100%" h={`${height}px`} overflow="hidden">
          <Box
            w={[vw(600), '986px']}
            pos="relative"
            onClick={(e: React.MouseEvent<HTMLElement, MouseEvent>) => {
              e.stopPropagation()
            }}
          >
            <Box w={[vw(600), '660px']} m="0 auto">
              <Box w="100%" h={[vw(400), '483px']}>
                <AnimatedCarousel w="100%" h="100%" from={from} to={to} progress={styles.progress} fit="contain" />
              </Box>
              <Box mt={[vw(40), '40px']} fontSize={[vw(20), '14px']} fontFamily="body" lineHeight="2em">
                <LocalizedText localizeKey={products[current].title} />
                <LocalizedText localizeKey={products[current].credit} />
              </Box>
            </Box>
            {products.length > 1 && (
              <Box
                display="flex"
                justifyContent="space-between"
                mt={[vw(50), 0]}
                pos={['static', 'absolute']}
                w="100%"
                top={['auto', '186px']}
              >
                <Button
                  variant="unstyled"
                  w={[vw(50), '101px']}
                  h={[vw(56), '111px']}
                  onClick={() => handleClick(false)}
                >
                  <Image src={`/images/modal_arrow_left_${platform}.png`} w="100%" h="100%" />
                </Button>
                <Button
                  variant="unstyled"
                  w={[vw(50), '101px']}
                  h={[vw(56), '111px']}
                  onClick={() => handleClick(true)}
                >
                  <Image src={`/images/modal_arrow_right_${platform}.png`} w="100%" h="100%" />
                </Button>
              </Box>
            )}
          </Box>
        </Center>
      </Box>
    </>
  )
}

export default ArtistsModal
